// extracted by mini-css-extract-plugin
export default {"main-logo":"MainHeaderList_main-logo__13mFm","our-wallet":"MainHeaderList_our-wallet__uB30w","cart_btn":"MainHeaderList_cart_btn__7fMUT","cart-num":"MainHeaderList_cart-num__KCp6t"};